import React from 'react'
import { Box, Text } from '@chakra-ui/react'

export function Footer() {
  return (
    <Box
      as="footer"
      w="100%"
      py={8}
      px={6}
      borderTop="1px solid"
      borderColor="gray.100"
      bg="white"
    >
      <Text
        maxW="1280px"
        mx="auto"
        fontSize="sm"
        fontWeight="medium"
        color="gray.500"
        textAlign="center"
      >
        © 2026 EXCELLO. All rights reserved.
      </Text>
    </Box>
  )
}
